import { render, staticRenderFns } from "./AgentInfo_bak2.vue?vue&type=template&id=418d6534&scoped=true"
import script from "./AgentInfo_bak2.vue?vue&type=script&lang=js"
export * from "./AgentInfo_bak2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d6534",
  null
  
)

export default component.exports